module.exports = __webpack_public_path__ + "img/force3.73179677.png";